import { render, staticRenderFns } from "./IconRadioOff.vue?vue&type=template&id=6f772a9e&"
import script from "./IconRadioOff.vue?vue&type=script&lang=js&"
export * from "./IconRadioOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports